import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=e28aa838&scoped=true&"
import script from "./ProductsView.vue?vue&type=script&lang=js&"
export * from "./ProductsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28aa838",
  null
  
)

export default component.exports